import React from 'react';

const HeartInHands: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M16.894 68.205l-2.606-19.867a4.657 4.657 0 00-4.622-4.053A4.656 4.656 0 005 48.951v33.317a8.77 8.77 0 002.563 6.199l18.05 18.049a4.346 4.346 0 011.292 3.089v.372"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M57.549 110v-8.368c0-9.309-6.462-17.458-15.575-19.276a37.725 37.725 0 00-4.183-.591c-2.06-.197-3.987-1.052-5.455-2.52L22.83 69.74c-2.016-2.015-5.323-2.41-7.557-.591a5.48 5.48 0 00-.417 8.126L30.102 92.52m81.244-24.315l2.607-19.867a4.656 4.656 0 014.621-4.053 4.656 4.656 0 014.666 4.666v33.317a8.77 8.77 0 01-2.563 6.199l-18.049 18.049a4.344 4.344 0 00-1.293 3.089v.372"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M70.692 110v-8.368c0-9.309 6.462-17.458 15.575-19.276a37.732 37.732 0 014.184-.591c2.059-.197 3.986-1.052 5.454-2.52l9.506-9.506c2.016-2.015 5.323-2.41 7.558-.591a5.481 5.481 0 01.416 8.126L98.139 92.52"
    ></path>
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="4"
      d="M96.978 36.115c0 22.869-32.857 38.837-32.857 38.837S31.264 59.006 31.264 36.115C31.264 26.192 39.105 18 48.787 18c6.594 0 12.355 3.746 15.334 9.266C67.1 21.746 72.86 18 79.454 18c9.682 0 17.524 8.214 17.524 18.115z"
    ></path>
  </svg>
);

export default HeartInHands;
